export default "__VITE_ASSET__CXykU6ki__"